export default __webpack_public_path__ + "static/media/vision2.b95495e1.png";